(() => {
  'use strict';

  const VERSION = '2026-08-17-ui-v26';
  if (window.__ddUiV26 === VERSION) return;
  window.__ddUiV26 = VERSION;

  const CAROUSELS = [
    { section: '.section-dd-nn-promos', track: '.ddnn-promo-grid', label: 'Günün seçkileri' },
    { section: '.section-dd-featured-trend', track: '.ddft-editorial__grid', label: 'Öne çıkan tasarımlar' },
    { section: '.section-dd-home-inspiration-lite', track: '.dd-home-blog-editorial__grid', label: 'İlham yazıları' }
  ];

  function rootsIn(scope, selector) {
    const out = [];
    if (scope?.matches?.(selector)) out.push(scope);
    scope?.querySelectorAll?.(selector).forEach(node => out.push(node));
    return out;
  }

  function makeButton(label, glyph) {
    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('aria-label', label);
    button.textContent = glyph;
    return button;
  }

  function enhanceCarousel(section, track, label) {
    if (!section || !track || track.dataset.ddv26Carousel === '1') return;
    track.dataset.ddv26Carousel = '1';
    if (!track.id) track.id = `ddv26-carousel-${Math.random().toString(36).slice(2, 9)}`;

    const nav = document.createElement('div');
    nav.className = 'ddv26-carousel-nav';
    nav.setAttribute('aria-label', `${label} gezinme`);
    const prev = makeButton(`${label}: önceki`, '←');
    const next = makeButton(`${label}: sonraki`, '→');
    prev.setAttribute('aria-controls', track.id);
    next.setAttribute('aria-controls', track.id);
    nav.append(prev, next);
    track.parentNode.insertBefore(nav, track);

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function step(direction) {
      const first = track.children[0];
      if (!first) return;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      const amount = first.getBoundingClientRect().width + gap;
      track.scrollBy({ left: direction * amount, behavior: prefersReduced.matches ? 'auto' : 'smooth' });
    }

    let frame = 0;
    function update() {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      });
    }

    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* Any shared card created client-side must also carry a stock state. Server-rendered cards keep their exact low-stock label. */
  function ensureStock(scope) {
    rootsIn(scope, '.ddnn-card').forEach(card => {
      if (card.querySelector('.ddnn-card__stock')) return;
      const media = card.querySelector('.ddnn-card__media');
      if (!media) return;

      const available = String(card.dataset.variantAvailable || 'true') !== 'false';
      const stock = document.createElement('div');
      stock.className = `ddnn-card__stock${available ? '' : ' is-sold-out'}`;
      const dot = document.createElement('span');
      dot.className = 'ddnn-card__stock-dot';
      dot.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.textContent = available ? 'Stokta' : 'Tükendi';
      stock.append(dot, text);
      media.appendChild(stock);
    });
  }

  function boot(scope = document) {
    CAROUSELS.forEach(config => {
      rootsIn(scope, config.section).forEach(section => {
        enhanceCarousel(section, section.querySelector(config.track), config.label);
      });
    });
    ensureStock(scope);
  }

  function start() {
    boot(document);
    document.addEventListener('shopify:section:load', event => boot(event.target || document));
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
